import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ElementFormComponent} from './element-form/element-form.component';
import {TechnicalDeviceResolver} from './services/technical-device.resolver';
import {SharedModule} from '@helpers/modules/shared.module';
import {TechnicalDeviceGroupsWithParamsResolver} from './services/technical-device-groups-with-params.resolver';
import { ElementFormOrderFieldsComponent } from './components/element-form-order-fields/element-form-order-fields.component';
import { ElementFormOrderSelectionComponent } from './components/element-form-order-selection/element-form-order-selection.component';
import {DynamicFieldsModule} from '@subforms/dynamic-fields/dynamic-fields.module';
import {ObjectsCommonComponentsModule} from '../objects-common-components/objects-common-components.module';
import {IconsModule} from '@lab365/icons';

@NgModule({
    declarations: [
        ElementFormComponent,
        ElementFormOrderFieldsComponent,
        ElementFormOrderSelectionComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        DynamicFieldsModule,
        ObjectsCommonComponentsModule,
        IconsModule,
    ],
    providers: [
        TechnicalDeviceResolver,
        TechnicalDeviceGroupsWithParamsResolver,
    ]
})
export class ElementModule {
}
